module.exports = __webpack_public_path__ + "assets/cloudinary.7c681d6b.svg";